export const CHECKOUT_URL = 'https://armonia-interior.impultienda.ar/checkout'
export const OFFER_ANCHOR = '#oferta'
